import IconArrowRightBold from '@creditflowresearch/uilib/Icon/IconArrowRightBold';
import { Link } from '@framework/router/Next/Link';
import Flex from '@creditflowresearch/uilib/Flex';
import URL from '@/creditflowresearch/Router/urlConstants';

import styles from './breadcrumb.module.scss';

export interface IBreadcrumb {
  title: string,
  url?: string,
  isActive?: boolean,
  withParentLink?: boolean,
}

const Breadcrumb = ({
  title,
  isActive,
  url,
  withParentLink,
}: IBreadcrumb) => (
  <Flex align="center" className={ styles.linkWrapper }>
    { isActive || !url ? <p className={ styles.inactiveLink }>{ title }</p> : (
      <>
        <Link
          className={ styles.link }
          to={ url }
        >
          { title }
        </Link>
        { withParentLink && (
        <>
          <div className={ styles.parentLinkDiv } />
          <Link
            className={ styles.link }
            to={ URL.SPONSORS_LIST }
          >
            Parent Companies
          </Link>
        </>
        ) }
        <IconArrowRightBold className={ styles.breadcrumbsIcon } />
      </>
    ) }
  </Flex>
);

export default Breadcrumb;
